module.exports = __webpack_public_path__ + "media/entities/2101-0cabb898.png";